import { render } from "./TypeTopNav.vue?vue&type=template&id=b5b83b8e"
import script from "./TypeTopNav.vue?vue&type=script&lang=js"
export * from "./TypeTopNav.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ranjanbajracharya/Documents/upwork/kaz/avidvantage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__